import { createSelector } from 'reselect';

export const getModals = (state) => state.modal.modals;

export const getIsModalOpen = (state, name) =>
  !!state.modal.modals[name] && state.modal.modals[name].isOpen;

export const getPayload = (state, name) =>
  (state.modal.modals[name] ? state.modal.modals[name].payload : {});

export const getModalNames = createSelector(
  [getModals],
  (modals) => Object.keys(modals),
);
